import { FC, memo } from 'react'
import { Row, Col, Breadcrumb, Content } from '@/client/components'
import Page from '@/client/submodules/Page'
import * as S from './styles'
import { ThankYouSurveyProps } from './types'

export const ThankYouSurvey: FC<ThankYouSurveyProps> = memo(({ seo, header, footer, content }) => {
  const { breadcrumb, description } = content

  return (
    <Page seo={seo} header={header} footer={footer} noIndex={true}>
      {breadcrumb && (
        <S.RowBreadcrumb>
          <Col>
            <Breadcrumb pages={breadcrumb} />
          </Col>
        </S.RowBreadcrumb>
      )}

      <Row>
        <Col>{description && <Content content={description} />}</Col>
      </Row>
    </Page>
  )
})

ThankYouSurvey.displayName = 'ThankYouSurvey'
